import { render, staticRenderFns } from "./ModulePendenciesExpired.vue?vue&type=template&id=f3bc5cb4"
import script from "./ModulePendenciesExpired.vue?vue&type=script&lang=js"
export * from "./ModulePendenciesExpired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports